document.addEventListener("DOMContentLoaded", () => {
  // 1) Only run if <body> has the class "template-collection"
  if (!document.body.classList.contains("template-collection")) {
    return;
  }

  // 2) Select the <header> element
  const header = document.querySelector("header");
  if (!header) {
    console.warn("<header> not found.");
    return;
  }

  // 3) By default, add "header_sticky_enabled" on page load
  header.classList.add("header_sticky_enabled");
  // Ensure we remove any leftover "disabled" class
  header.classList.remove("header_sticky_disabled");

  // 4) Define a scroll handler to toggle classes
  const handleScroll = () => {
    if (window.scrollY >= 150) {
      // If scrolled >= 150px, remove "enabled" and add "disabled"
      header.classList.remove("header_sticky_enabled");
      header.classList.add("header_sticky_disabled");
    } else {
      // If scrolled < 150px, add "enabled" and remove "disabled"
      header.classList.add("header_sticky_enabled");
      header.classList.remove("header_sticky_disabled");
    }
  };

  // 5) Run scroll check immediately (in case we're already scrolled on page load)
  handleScroll();

  // 6) Attach the scroll listener
  window.addEventListener("scroll", handleScroll);
});
